<script>
  import { writable } from 'svelte/store';

  export let id;
  export let significant;
  export let aantalLetters;

  const henk = writable(setHenk());
  henk.subscribe((value) => {
    let valueString = JSON.stringify(value);
    window.localStorage.setItem(id, valueString);
  }); 

  function setHenk() {
    const x = JSON.parse(window.localStorage.getItem(id));
    return x !== null ? x : new Array(aantalLetters);
  }
</script>

<form {id} style="--start: {8 - significant}" autocomplete="off">
  <label>{id}</label>
  {#each Array(aantalLetters) as _, i}
    <input
      id="{id}.{i}"
      bind:value={$henk[i]}
      class={i === significant ? "significant " : ""}
      minlength="1"
      maxlength="1"
      on:focus={(e) => e.target.select()}
      on:input={(e) =>
        e.target.nextSibling !== null
          ? e.target.nextSibling.focus()
          : e.target.select()}
    />
  {/each}
</form>

<style>
  form {
    grid-column-start: var(--start);
    grid-column-end: span aantalLetters;
  }
  label {
    display: inline;
    font-family: Verdana, Geneva, Tahoma, sans-serif;
    font-size: 10px;
    grid-column: 1 / 1;
  }
  input {
    margin: 0;
    width: 2em;
    caret-color: transparent;
    text-align: center;
  }
  input.significant {
    background-color: gold;
  }
  input:focus {
    border: 1px solid black;
    outline: none;
  }
  input::selection {
    background: none;
  }
</style>
